<ng-container *ngFor="let child of children; index as idx">
    <div>
        <form [formGroup]="childForms[idx]" *ngIf="formFields.length > 0 && formFields[idx].length > 0">
            <div>
                <label class="govuk-details__summary">
                    <span class="govuk-details__summary-text" id="summary-child-{{idx+1}}" #child>
                        <span *ngIf="formId === 'address_registration_form'">Address</span>
                        <span *ngIf="formId === 'vehicle_registration_form'">Vehicle</span>
                        <span *ngIf="!overrideCounter"> {{idx+1}} of {{maxChildren}}</span>
                        <span *ngIf="overrideCounter"> {{overrideCounter}}</span>
                    </span>
                    <!---->
                </label>
                <span *ngIf="children.length > 1 && idx > 0 && useCloseButtons === true" class="close-button">
                    <button class="close-text" data-module="govuk-button" (click)="removeChildAtIndex(idx)">
                        Close X
                    </button>
                </span>
                <br>
                <br>
                <div>
                    <span *ngIf="children.length > 1 && idx > 0 && useCloseButtons === false">
                        <button data-prevent-double-click="true" class="btn govuk-button button-sizer btn-primary"
                            data-module="govuk-button" (click)="removeChildAtIndex(idx)">
                            Remove
                            <ng-container *ngIf="formId === 'address_registration_form'">address</ng-container>
                            <ng-container *ngIf="formId === 'vehicle_registration_form'">vehicle</ng-container>
                        </button>
                        <br>
                        <br>
                    </span>
                    <ng-container *ngFor="let field of formFields[idx]">
                        <div class="form-group">
                            <ng-container *ngIf="formService.shouldShowConditional(formId, field,childForms[idx])">
                                <ng-container
                                    *ngIf="field.type !== 'checkbox' && field.type !== 'radio' && field.type !== 'dropdown' && field.type !== 'heading' && field.type !== 'submit'">
                                    <p class="govuk-label-wrapper"
                                        *ngIf="field.title !== 'Address' ||  addresses[idx].length > 0">
                                        <label for="{{field.field}}">
                                            <span *ngIf="field.required" aria-hidden="true"
                                                class="form-field-required-marker">
                                                *</span> {{" "}} <span [innerHTML]="field.title"></span>
                                        </label>
                                    </p>
                                    <ng-container *ngIf="field.helptext">
                                        <div id="{{field.field}}-hint" class="govuk-hint" [innerHTML]="field.helptext">
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="field.type == 'text'">
                                        <ng-container
                                            *ngIf="field.title !== 'Vehicle registration' && field.title !== 'Address' && field.title !== 'Postcode'">
                                            <input id="{{field.field}}" type="text" formControlName="{{field.field}}"
                                                *ngIf="field.title !== 'Vehicle make' && field.title !== 'Vehicle colour'"
                                                class="form-control">
                                            <span *ngIf="field.title === 'Vehicle make' || field.title === 'Vehicle colour'">
                                                <span *ngIf="vehicleStatus[idx] !== 1">
                                                    <input id="{{field.field}}" type="text" formControlName="{{field.field}}"
                                                    oninput="this.value = this.value.replaceAll(' ','').toUpperCase()"
                                                    class="form-control">
                                                </span>
                                                <span *ngIf="vehicleStatus[idx] === 1">
                                                    <input id="{{field.field}}" type="text" formControlName="{{field.field}}"
                                                    oninput="this.value = this.value.replaceAll(' ','').toUpperCase()"
                                                    class="form-control" disabled>
                                                </span>
                                            </span>
                                        
                                        </ng-container>
                                        <ng-container *ngIf="field.title === 'Vehicle registration'">
                                            <div class="form-group">
                                                <div class="row ml-0 mr-0">
                                                    <input (keydown.space)="$event.preventDefault();"
                                                        (keydown.spacebar)="$event.preventDefault();" type="text"
                                                        class="form-control col-sm-8" maxlength="12"
                                                        formControlName="{{field.field}}" role="textbox"
                                                        (keydown)="resetVehicleDetails(idx)" id="{{field.field}}"
                                                        oninput="this.value = this.value.replace(/\s/g, '').toUpperCase()">
                                                    <button type="button"
                                                        class="btn btn-primary govuk-button button-sizer col-sm-4 mb-0"
                                                        [disabled]="!childForms[idx].get(field.field).valid"
                                                        (click)="getVehicle(idx)">Find vehicle</button>
                                                </div>

                                                <div *ngIf="this.childForms[idx].duplicateAddressError">
                                                    <span style="font-weight:bolder; color: #c90505;"
                                                        class="invalid-feedback">
                                                        Vehicle registration already in use
                                                    </span>
                                                </div>

                                                <span *ngIf="vehicleStatus[idx] == 1"
                                                    style="color: #36B37E; font-weight: 600;">Vehicle found.</span>

                                                <span *ngIf="vehicleStatus[idx] == 2"
                                                    style="color: #c90505; font-weight: 600;">Vehicle not found, please
                                                    check your registration. If it's correct, enter your vehicle
                                                    make and type below.</span>

                                                <span *ngIf="vehicleStatus[idx] == 3"
                                                    style="color: #c90505; font-weight: 600;">Vehicle not found, please
                                                    check your registration. If it's correct, enter your vehicle
                                                    make and type below.</span>

                                            </div>

                                            <!-- 
                                                <input type="text" class="form-control mb-3" formControlName="{{question.reference}}"
                                                    attr.aria-label="{{question.name}} input field"
                                                    oninput="this.value = this.value.toUpperCase().replace(' ','').substr(0,10)"> -->

                                        </ng-container>
                                        <ng-container *ngIf="field.title === 'Postcode'">
                                            <div class="row ml-0 mr-0">
                                                <input (keydown.space)="$event.preventDefault();"
                                                    (keydown.spacebar)="$event.preventDefault();" type="text"
                                                    class="form-control col-sm-8" formControlName="postcode"
                                                    autocomplete="postal-code" role="textbox" id="{{field.field}}"
                                                    oninput="this.value = this.value.replaceAll(' ','').toUpperCase()">
                                                <button type="button"
                                                    class="btn btn-primary govuk-button button-sizer col-sm-4 mb-0"
                                                    [disabled]="!field.value || !regExPostcode.test(field.value)"
                                                    (click)="getAddress(idx)">Find address</button>
                                            </div>
                                            <div *ngIf="field.errors?.addressNotFound" role="alert" tabindex="0"
                                                class="invalid-feedback">
                                                {{field.errors?.addressNotFound}}</div>
                                            {{field.errors}}
                                            <div *ngIf="field.errors?.invalidPostcode" role="alert" tabindex="0"
                                                class="invalid-feedback">
                                                {{field.errors?.invalidPostcode}}</div>

                                        </ng-container>
                                        <ng-container *ngIf="field.title === 'Address'">
                                            <div class="form-group" *ngIf="addresses[idx].length > 0">
                                                <select formControlName="address" class="form-control"
                                                    (change)="checkAddresses(idx)" id="{{field.field}}"
                                                    attr.aria-label="Select address">
                                                    <option value="">Please select</option>
                                                    <option *ngFor="let item of addresses[idx]"
                                                        [ngValue]="item.address.ADDRESS"
                                                        [selected]="this.childForms[idx].controls['address'].value === item?.address.ADDRESS">
                                                        {{item?.address.ADDRESS}}
                                                    </option>
                                                </select>
                                            </div>
                                            <div *ngIf="this.childForms[idx].duplicateAddressError">
                                                <span style="font-weight:bolder; color: #c90505;"
                                                    class="invalid-feedback">
                                                    Address already in use
                                                </span>
                                            </div>
                                            <div *ngIf="this.childForms[idx].value.address">
                                                <span
                                                    *ngIf="!localAddress(getPostcodeDetails(this.childForms[idx].value.address,idx).address)"
                                                    style="font-weight:bolder; color: #c90505;"
                                                    class="invalid-feedback">
                                                    As this address is not within the Kent administrative area, a
                                                    £10 per visit cross-border fee will be applicable when disposing
                                                    of waste from this address. Payment on arrival (card payments
                                                    only).
                                                    Please see our <a target="_blank"
                                                        href="https://kent.gov.uk/hwrccrossborder">cross
                                                        border policy</a> for more information.
                                                </span>
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                    <ng-container *ngIf="field.type == 'date'">
                                        <input id="{{field.field}}" type="date" formControlName="{{field.field}}"
                                            class="form-control"
                                            [ngClass]="{'govuk-input': true, 'govuk-input--error':  childForms[idx].get(field.field)?.errors }">
                                    </ng-container>

                                    <ng-container *ngIf="field.type == 'number'">
                                        <input id="{{field.field}}" type="number" formControlName="{{field.field}}"
                                            class="form-control"
                                            [ngClass]="{'govuk-input': true, 'govuk-input--error':  childForms[idx].get(field.field)?.errors }">
                                    </ng-container>

                                    <ng-container *ngIf="field.type == 'email'">
                                        <input id="{{field.field}}" type="email" formControlName="{{field.field}}"
                                            class="form-control"
                                            [ngClass]="{'govuk-input': true, 'govuk-input--error':  childForms[idx].get(field.field)?.errors }">
                                    </ng-container>

                                    <ng-container *ngIf="field.type == 'textarea'">
                                        <textarea id="{{field.field}}" formControlName="{{field.field}}"
                                            class="form-control"
                                            [ngClass]="{'govuk-textarea': true, 'govuk-textarea--error':  childForms[idx].get(field.field)?.errors }"></textarea>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="field.type == 'checkbox'">
                                    <ng-container
                                        *ngIf="formService.shouldShowConditional(formId, field,childForms[idx])">
                                        <div class="govuk-form-group">
                                            <fieldset class="govuk-fieldset" aria-describedby="field.name+'-hint'">
                                                <ng-container *ngIf="field.helptext">
                                                    <div id="{{field.field}}-hint" class="govuk-hint"
                                                        [innerHTML]="field.helptext">
                                                    </div>
                                                </ng-container>
                                                <div class="form-check" data-module="govuk-checkboxes">
                                                    <div class="govuk-checkboxes__item">
                                                        <input class="govuk-checkboxes__input" id="{{field.field}}"
                                                            class="form-check-input" type="checkbox"
                                                            formControlName="{{field.field}}"
                                                            [attr.checked]="field.value ? field.value : null">
                                                        <label class="form-check-label" for="{{field.field}}">
                                                            <span *ngIf="field.required" aria-hidden="true"
                                                                class="form-field-required-marker">
                                                                *</span> {{" "}} <span [innerHTML]="field.title"></span>
                                                        </label>
                                                    </div>

                                                </div>
                                            </fieldset>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="field.type == 'radio'">
                                    <ng-container
                                        *ngIf="formService.shouldShowConditional(formId, field,childForms[idx])">
                                        <div class="govuk-form-group">
                                            <fieldset class="govuk-fieldset" id="{{field.field}}">
                                                <p class="govuk-label-wrapper">
                                                    <label for="field.field">
                                                        <span *ngIf="field.required" aria-hidden="true"
                                                            class="form-field-required-marker">
                                                            *</span> {{" "}} <span [innerHTML]="field.title"></span>
                                                    </label>
                                                </p>
                                                <ng-container *ngIf="field.helptext">
                                                    <div id="{{field.field}}-hint" class="govuk-hint"
                                                        [innerHTML]="field.helptext">
                                                    </div>
                                                </ng-container>
                                                <div class="form-check" data-module="govuk-radios">
                                                    <div class="govuk-radios__item" tabindex="0"
                                                        (keypress)="keypressOnRadio($event)">
                                                        <input class="govuk-radios__input" id="{{field.field}}yes"
                                                            class="form-check-input" type="radio" value="true"
                                                            formControlName="{{field.field}}"
                                                            [attr.checked]="field.value ? field.value : null"
                                                            tabindex="-1" name="{{field.field}}">
                                                        <label class="form-check-label" for="{{field.field}}yes">
                                                            Yes
                                                        </label>
                                                    </div>
                                                    <div class="govuk-radios__item" tabindex="0"
                                                        (keypress)="keypressOnRadio($event)">
                                                        <input class="govuk-radios__input" id="{{field.field}}no"
                                                            class="form-check-input" type="radio" value="false"
                                                            formControlName="{{field.field}}"
                                                            [attr.checked]="field.value ? field.value : null"
                                                            tabindex="-1" name="{{field.field}}">
                                                        <label class="form-check-label" for="{{field.field}}no">
                                                            No
                                                        </label>
                                                    </div>
                                                </div>
                                            </fieldset>
                                        </div>
                                    </ng-container>

                                </ng-container>
                                <ng-container *ngIf="field.type == 'dropdown'">
                                    <p class="govuk-label-wrapper">
                                        <label class="govuk-label govuk-label--s" for="field.field">
                                            <span *ngIf="field.required" aria-hidden="true"
                                                class="form-field-required-marker">
                                                *</span> {{" "}} <span [innerHTML]="field.title"></span>
                                        </label>
                                    </p>
                                    <ng-container *ngIf="field.helptext">
                                        <div id="{{field.field}}-hint" class="govuk-hint" [innerHTML]="field.helptext">
                                        </div>
                                    </ng-container>
                                    <select class="govuk-select" id="{{field.field}}" class="form-control selectpicker"
                                        formControlName="{{field.field}}" aria-label="field.field">
                                        <option value="">Please select</option>
                                        <ng-container *ngFor="let opt of field.options">
                                            <option *ngIf="opt.visible" value="{{opt.value}}">{{opt.title}}</option>
                                        </ng-container>
                                    </select>
                                </ng-container>
                                <ng-container *ngIf="field.type == 'heading'">
                                    <p class="govuk-label-wrapper">
                                        <label for="field.field">
                                            <span [innerHTML]="field.title"></span>
                                        </label>
                                    </p>
                                    <ng-container *ngIf="field.helptext">
                                        <div id="{{field.field}}-hint" class="govuk-hint" [innerHTML]="field.helptext">
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="field.type == 'submit'">
                                    <ng-container *ngIf="field.helptext">
                                        <div id="{{field.field}}-hint" class="govuk-hint" [innerHTML]="field.helptext">
                                        </div>
                                    </ng-container>
                                    <div *ngIf="showSubmit">
                                        <button data-prevent-double-click="true"
                                            class="btn btn-primary govuk-button button-sizer" data-module="govuk-button"
                                            (click)="submit(formId)">
                                            {{field.title}}
                                        </button>
                                    </div>
                                </ng-container>
                                <ng-container *ngIf="field.type == 'button'">
                                    <ng-container *ngIf="field.helptext">
                                        <div id="{{field.field}}-hint" class="govuk-hint" [innerHTML]="field.helptext">
                                        </div>
                                    </ng-container>
                                    <div>
                                        <button data-prevent-double-click="true"
                                            class="btn btn-primary govuk-button button-sizer"
                                            data-module="govuk-button govuk-button button-sizer--secondary nhsuk-button--secondary">
                                            {{field.title}}
                                        </button>
                                    </div>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="childForms[idx].get(field.field)?.errors && submitted">
                                <p *ngIf="childForms[idx].get(field.field)?.errors.required" class="invalid-feedback">
                                    {{ field.title }} is required
                                </p>
                            </ng-container>
                            <span *ngIf="field.field === 'is_this_a_restricted_vehicle'">
                                <ng-container
                                    *ngIf="this.restrictedVehiclesLimitExceed && idx >= firstExtraRestricted && field.value === 'true'">
                                    <p class="invalid-feedback">
                                        You can only have 1 restricted vehicle on your account. Please remove this
                                        vehicle.
                                    </p>
                                </ng-container>
                            </span>

                        </div>
                    </ng-container>
                </div>
            </div>
        </form>
    </div>
    <hr *ngIf="idx < children.length -1">
</ng-container>
<ng-container *ngIf="children.length < maxChildren">
    <div class="govuk-button-group">
        <button data-prevent-double-click="true" class="btn btn-primary govuk-button button-sizer col-sm-6 mb-0"
            data-module="govuk-button" (click)="addChild()">
            Add another
            <ng-container *ngIf="formId === 'address_registration_form'">address</ng-container>
            <ng-container *ngIf="formId === 'vehicle_registration_form'">vehicle</ng-container>
        </button>
    </div>
</ng-container>